// extracted by mini-css-extract-plugin
export default {"Input":"input_Input__a3-Tq","Label":"input_Label__WJTd1"};